import React, { useState } from 'react'

import AWS from 'aws-sdk'

import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import Grow from '@material-ui/core/Grow'

const useStyles = makeStyles((theme) => ({
  formControl: {
    // minWidth: 220,
    width: 220,
    margin: 'auto',
    fontSize: '12px !important',
    '& .MuiOutlinedInput-root': {
      height: 37,
      fontSize: '12px !important',
    },
    '& .MuiSelect-outlined': {
      height: 37,
      fontSize: '12px !important',
    },
    '& .MuiSelect-select': {
      height: 37,
      fontSize: '12px !important',
    },
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
}))

function FilesMenu(props) {
  const classes = useStyles()

  const crs = [
    { id: 'DD', tag: 'Decimal Degrees' },
    { id: 'DMS', tag: 'Degrees Minutes Seconds' },
    { id: 'UTM', tag: 'Universal Transverse Mercator' },
  ]

  return (
    <Grow in={props.CRS}>
      <div className="files-menu">
        <div style={{ color: 'black', height: '20px', display: 'flex' }}>
          <label className="on-click-title">Coordinate System</label>
          <CloseIcon
            style={{
              fontSize: '19px',
              position: 'relative',
              margin: 'auto',
              marginRight: '5px',
              cursor: 'pointer',
            }}
            onClick={() => props.setCRS(false)}
          />
        </div>
        <div className="info-container" style={{ padding: '10px' }}>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel htmlFor="outlined-age-native-simple">CRS</InputLabel>
            <Select native onChange={(evt, val) => props.setCRSID(evt.target.value)} autoWidth={true} label="CRS">
              {crs.map((val) => (
                <option value={val.id}>{val.tag}</option>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </Grow>
  )
}

export default FilesMenu
